export default Object.freeze({
    TOTALS: 'totals',
    INSTANCE: 'instance',
    INSTANCES: 'instances',
    LIST: 'list',
    CUSTOMERS: 'customers',
    ALL_CUSTOMERS: 'all_customers',
});
